import React from 'react';

import style from './style.module.scss';
import Icon from '@components/icon-component';
import MapField from './map-field';

const MoreInfoContainer = ({
  setOpenAddFieldModalEvent,
  moreInfoFormFields,
  errors,
  register,
  watch,
  getValues,
  control,
  setValue,
  isInputReconcile,
  isSelectBoxReconcile,
  isTextBoxUnitReconcile
}) => {
  return (
    <>
      <div className={style.divider}>
        <p>More info</p>
      </div>

      {moreInfoFormFields?.length > 0 ? (
        <div className={style.formFields}>
          {moreInfoFormFields?.map((field, index) => {
            return (
              <div
                className={index === moreInfoFormFields?.length - 1 ? '' : style['mb-16']}
                key={field?.order}
                style={{
                  marginTop: '16px'
                }}
              >
                <MapField
                  field={field}
                  errors={errors}
                  register={register}
                  watch={watch}
                  getValues={getValues}
                  control={control}
                  setValue={setValue}
                  isInputReconcile={isInputReconcile}
                  isSelectBoxReconcile={isSelectBoxReconcile}
                  isTextBoxUnitReconcile={isTextBoxUnitReconcile}
                  showReconcileFeatherIconWhenValueChanged
                  moreFields
                />
              </div>
            );
          })}
        </div>
      ) : (
        <></>
      )}

      <div
        className={`${style.addMoreInfoBody} ${moreInfoFormFields?.length === 0 && style.padTop24}`}
      >
        <p className={style.addPSVs} onClick={() => setOpenAddFieldModalEvent({ value: true })}>
          <Icon name={'add-icon'} style={{ marginRight: '4px' }} />
          Add field
        </p>
      </div>
    </>
  );
};

export default MoreInfoContainer;
